import React from 'react';
import { Checkbox as HeroCheckbox } from '@heroui/react';

interface CheckboxProps {
  isSelected?: boolean;
  isIndeterminate?: boolean;
  onChange?: (isSelected: boolean) => void;
  children?: React.ReactNode;
  className?: string;
  isDisabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  label?: string;
  description?: string;
  showIcon?: boolean;
  linkedTitle?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  isSelected = false,
  isIndeterminate = false,
  onChange,
  children,
  className = '',
  isDisabled = false,
  size = 'md',
  color = 'primary',
  label,
  description,
  linkedTitle,
  showIcon = false,
}) => {
  // Check if we're on partner app by pathname
  const isPartner =
    typeof window !== 'undefined' && window.location.pathname.startsWith('/partner');

  // Add partner-checkbox or client-checkbox class for CSS styling from index.css
  const checkboxWrapperClass = isPartner ? 'partner-checkbox' : 'client-checkbox';

  // Partner styles via classNames - override the after:bg-secondary with blue
  const partnerClassNames = isPartner
    ? {
        wrapper: 'after:!bg-partner after:!text-white',
        icon: '!text-white',
      }
    : undefined;

  return (
    <div className={`flex items-start gap-0 ${checkboxWrapperClass} ${className}`}>
      <HeroCheckbox
        isSelected={isSelected}
        isIndeterminate={isIndeterminate}
        onValueChange={onChange}
        isDisabled={isDisabled}
        size={size}
        color={isPartner ? 'default' : color}
        classNames={partnerClassNames}
      />

      {(children || label || description) && (
        <div className="flex flex-col">
          {children || (
            <>
              {label && (
                <div className="flex items-center gap-2 mb-0.5">
                  <span
                    className={`text-sm font-medium ${linkedTitle ? (isPartner ? 'text-partner' : 'text-primary') : 'text-black'}`}
                  >
                    {label}
                  </span>
                </div>
              )}
              {description && (
                <span className="text-sm text-auth-muted leading-5">{description}</span>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};
